import React, { useContext, useEffect } from 'react'
import { FormControl, Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material'
import { useFormContext, Controller } from 'react-hook-form'
import { WhatsappDataContext } from '../WhatsappMessageContent'

const MessageTypeSelection = () => {
    const {initialWhatsappData} = useContext(WhatsappDataContext);
  const { control, formState: { errors },watch,reset } = useFormContext();
    
  return (
    <>
        <FormControl component="fieldset">
            <Typography gutterBottom sx={{ 
                fontWeight: 600, 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                mb: 1.5,
                fontSize:'0.8rem'
            }}>
                Choose Message Type
            </Typography>
            <Controller
                name="messageType"
                control={control}
                rules={{ required: 'Select message type' }}
                render={({ field }) => (
                    <RadioGroup {...field} row>
                        <FormControlLabel value="text" control={<Radio />} label={<Typography sx={{ fontSize: '0.8rem' }}>Text</Typography>} />
                        <FormControlLabel value="template" control={<Radio />} label={<Typography sx={{ fontSize: '0.8rem' }}>Template</Typography>} />
                        <FormControlLabel value="media" control={<Radio />} label={<Typography sx={{ fontSize: '0.8rem' }}>Media</Typography>} />
                        <FormControlLabel value="button" control={<Radio disabled/> } label={<Typography sx={{ fontSize: '0.8rem',color:'gray' }}>Button</Typography>} />
                        <FormControlLabel value="list" control={<Radio disabled/>} label={<Typography sx={{ fontSize: '0.8rem',color:'gray' }}>List</Typography>} />
                    </RadioGroup>
                )}
            />
            {errors.messageType && (
                <Typography color="error" sx={{ fontSize: '0.7rem' }}>{errors.messageType.message}</Typography>
            )}
        </FormControl>
    </>
  )
}

export default MessageTypeSelection
